import { Descriptions, Tag } from 'antd';
import { formatDate, formatDateTime } from 'utils/formatDate';
import { renderEventType } from './config';

const ItemDetail = ({ item }) => (
  <Descriptions column={1} bordered>
    <Descriptions.Item label="ID">{item.id}</Descriptions.Item>
    <Descriptions.Item label="Symbol">
      <Tag color="blue">{item.symbol}</Tag>
    </Descriptions.Item>
    <Descriptions.Item label="Wifeed ID">{item.wifeed_id}</Descriptions.Item>
    <Descriptions.Item label="Event">
      {item.event_type_label || '-'}
    </Descriptions.Item>
    <Descriptions.Item label="Event Type">
      {renderEventType(item.event_type) || '-'}
    </Descriptions.Item>
    <Descriptions.Item label="Title">{item.title || '-'}</Descriptions.Item>
    <Descriptions.Item label="Announce Date">
      {formatDate(item.announce_date) || '-'}
    </Descriptions.Item>
    <Descriptions.Item label="Record Date">
      {formatDate(item.record_date) || '-'}
    </Descriptions.Item>
    <Descriptions.Item label="Execute Date">
      {formatDate(item.execute_date) || '-'}
    </Descriptions.Item>
    <Descriptions.Item label="Document">
      {item.event_url ? (
        <a href={item.event_url} target="_blank" rel="noreferrer">
          {item.event_url}
        </a>
      ) : (
        '-'
      )}
    </Descriptions.Item>
    <Descriptions.Item label="Event Doc">
      {/^https?:\/\//.test(item.event_doc || '') ? (
        <a href={item.event_doc} target="_blank" rel="noreferrer">
          {item.event_doc}
        </a>
      ) : (
        item.event_doc || '-'
      )}
    </Descriptions.Item>
    <Descriptions.Item label="Created At">
      {formatDateTime(item.created_at)}
    </Descriptions.Item>
    <Descriptions.Item label="Updated At">
      {formatDateTime(item.updated_at)}
    </Descriptions.Item>
  </Descriptions>
);

export default ItemDetail;
